// extracted by mini-css-extract-plugin
module.exports = {"layout":"BillingPageSkeleton_layout__wnSTd"};